import {
    Card,
    CardContent,
    CardActions,
    Container,
    Button,
    Dialog,
    DialogTitle,
    IconButton,
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {Close} from '@material-ui/icons';
import {H6, PSingleLine} from 'components/TypographyShortcuts';
import {useContext, useState} from 'react';
import {UserContext} from 'context';
import {ViewMMC} from 'components/mmld/ViewMMC';
import {Show} from 'components';

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}));

const MMCDetailModal = ({open, setOpen}) => {
    const classes = useStyles();
    return (
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth='md'>
            <DialogTitle>
                MMC
                <IconButton
                    aria-label='close'
                    className={classes.closeButton}
                    onClick={() => setOpen(false)}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <ViewMMC />
        </Dialog>
    );
};

const ViewMMCMini = () => {
    const {
        mmlds,
        user: {mmld_number: mmldNumber},
    } = useContext(UserContext);
    const [showModal, setShowModal] = useState(false);

    const meta = mmlds?.recent_mmld_meta?.find(
        entry => entry.DOCUMENT_TYPE === 'MMC'
    );

    return (
        <>
            <Container maxWidth='sm'>
                <Card raised>
                    <Show condition={!!meta}>
                        <CardContent>
                            <H6>
                                MMC For {meta?.NAME_LAST}, {meta?.NAME_FIRST}
                            </H6>
                            <PSingleLine>Reference Number: {mmldNumber}</PSingleLine>
                        </CardContent>
                        <CardActions>
                            <Button
                                size='small'
                                color='primary'
                                onClick={() => setShowModal(true)}
                            >
                                View More Info
                            </Button>
                        </CardActions>
                    </Show>
                    <Show condition={!meta}>
                        <H6 color='seconary'>
                            Some error has occured. Please try again later.
                        </H6>
                    </Show>
                </Card>
            </Container>
            <MMCDetailModal open={showModal} setOpen={setShowModal} />
        </>
    );
};
export default ViewMMCMini;
